<div *ngIf="params">
  <span>{{title}}</span>
</div>
